import { useQuery, useQueryClient } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { fmtDateTime } from "@/lib/format";
import { PageHeader, Loading } from "@/components/Kpi";

export default function Notifications() {
  const qc = useQueryClient();
  const { data, isLoading } = useQuery({ queryKey: ["notifications"], queryFn: () => api.get("/notifications").then((r) => r.data) });
  if (isLoading) return <Loading />;
  const read = async (id) => { await api.post(`/notifications/${id}/read`); qc.invalidateQueries({ queryKey: ["notifications"] }); };
  return (
    <div>
      <PageHeader title="Notifiche" subtitle="Notifiche interne (la coda email è predisposta: campo email_queued)" />
      <ul className="space-y-2" data-testid="notifications-list">
        {(data || []).length === 0 && <li className="text-sm text-slate-500">Nessuna notifica</li>}
        {(data || []).map((n) => (
          <li key={n.id} className={`bg-white border rounded-md p-3 flex justify-between gap-3 ${n.read ? "opacity-60" : ""}`} data-testid={`notification-${n.id}`}>
            <div><div className="font-medium text-sm">{n.title}</div><div className="text-sm text-slate-600">{n.body}</div><div className="text-xs text-slate-400 mt-1">{fmtDateTime(n.created_at)} {n.project_id && <Link className="text-primary ml-2" to={`/operazioni/${n.project_id}`}>Apri operazione</Link>}</div></div>
            {!n.read && <button onClick={() => read(n.id)} className="text-xs text-primary hover:underline whitespace-nowrap" data-testid={`read-${n.id}`}>Segna letta</button>}
          </li>
        ))}
      </ul>
    </div>
  );
}
